exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".styles_codeEditorContainer__ZhfWq{position:relative;height:15rem;border:.0625rem solid #ccc}.styles_codeEditorContainerFullScreen__3zcZN{position:fixed;top:0;bottom:0;left:0;right:0;width:auto;height:auto;z-index:999;background:#fff}.styles_enterFullScreen__3y4A-{position:relative;text-align:right;float:right;padding-right:1.25rem;z-index:9}.styles_exitFullScreen__1unSG{text-align:right;position:absolute;z-index:2;top:0;right:0;left:0;padding:.5rem}", ""]);

// exports
exports.locals = {
	"codeEditorContainer": "styles_codeEditorContainer__ZhfWq",
	"codeEditorContainerFullScreen": "styles_codeEditorContainerFullScreen__3zcZN",
	"enterFullScreen": "styles_enterFullScreen__3y4A-",
	"exitFullScreen": "styles_exitFullScreen__1unSG"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/CodeEditor/styles.less
// module id = 1913
// module chunks = 8